/* Titan League · precios en la moneda del visitante (referencia) y limpieza del USD viejo */
(function () {
  if (window.__titanMoney) return;
  window.__titanMoney = true;

  var LIST = [
    { c: 'MXN', n: 'Peso mexicano', s: '$' },
    { c: 'COP', n: 'Peso colombiano', s: '$' },
    { c: 'ARS', n: 'Peso argentino', s: '$' },
    { c: 'CLP', n: 'Peso chileno', s: '$' },
    { c: 'PEN', n: 'Sol peruano', s: 'S/' },
    { c: 'USD', n: 'Dólar', s: '$' },
    { c: 'EUR', n: 'Euro', s: '€' },
    { c: 'BRL', n: 'Real brasileño', s: 'R$' },
    { c: 'GTQ', n: 'Quetzal', s: 'Q' },
    { c: 'DOP', n: 'Peso dominicano', s: 'RD$' },
    { c: 'UYU', n: 'Peso uruguayo', s: '$U' },
    { c: 'BOB', n: 'Boliviano', s: 'Bs' },
    { c: 'CRC', n: 'Colón', s: '₡' },
    { c: 'PAB', n: 'Balboa', s: 'B/.' }
  ];
  var BY_C = {};
  LIST.forEach(function (x) { BY_C[x.c] = x; });
  var rates = null, cur = null;

  function save(c) { try { localStorage.setItem('tl-cur', c); } catch (e) {} }
  function load() { try { return localStorage.getItem('tl-cur'); } catch (e) { return null; } }

  function guess() {
    var TZC={'America/Mexico_City':'MX','America/Cancun':'MX','America/Monterrey':'MX','America/Tijuana':'MX','America/Merida':'MX','America/Chihuahua':'MX','America/Hermosillo':'MX','America/Mazatlan':'MX','America/Matamoros':'MX','America/Ojinaga':'MX','America/Bahia_Banderas':'MX','America/Bogota':'CO','America/Argentina/Buenos_Aires':'AR','America/Santiago':'CL','America/Lima':'PE','America/Guatemala':'GT','America/Santo_Domingo':'DO','America/Montevideo':'UY','America/La_Paz':'BO','America/Costa_Rica':'CR','America/Panama':'PA','America/Sao_Paulo':'BR','Europe/Madrid':'ES'};
    var tz=''; try{tz=(Intl.DateTimeFormat().resolvedOptions().timeZone||'');}catch(e){}
    var l = (navigator.language || 'es-MX').toUpperCase();
    var map = { CO: 'COP', AR: 'ARS', CL: 'CLP', PE: 'PEN', US: 'USD', ES: 'EUR', BR: 'BRL', GT: 'GTQ', DO: 'DOP', UY: 'UYU', BO: 'BOB', CR: 'CRC', PA: 'PAB', MX: 'MXN' };
    if (TZC[tz]) return map[TZC[tz]] || 'MXN';
    if (tz && tz.indexOf('America/') === 0 && !TZC[tz]) return 'MXN';
    return map[(l.split('-')[1] || 'MX')] || 'MXN';
  }

  function fmt(v, c) {
    var info = BY_C[c] || { s: '' };
    var dec = (c === 'CLP' || c === 'COP' || c === 'ARS') ? 0 : (v >= 100 ? 0 : 2);
    return info.s + v.toLocaleString('es-MX', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + ' ' + c;
  }

  // 1) apaga el selector de monedas del tema: la tienda solo cobra en MXN
  function killSwitcher() {
    var sel = 'form[action*="/localization"], .localization-form, .disclosure--currency, [data-currency-selector], .header__localization';
    document.querySelectorAll(sel).forEach(function (n) { n.style.display = 'none'; });
  }

  // 2) quita el "$X USD" viejo de las fichas y del visor
  function killOldUsd() {
    document.querySelectorAll('#tlf-shop .tlf2-price span').forEach(function (s) {
      if (s.classList.contains('tl-alt')) return;
      if (/USD/i.test(s.textContent || '')) s.style.display = 'none';
    });
    var mu = document.getElementById('tlf2-modal-usd');
    if (mu) mu.style.display = 'none';
  }

  // 3) corrige los textos que decían que la tienda cobra en dólares
  function fixCopy() {
    document.querySelectorAll('#tlf-shop .tlf2-faq p, #tlf-shop .tlf2-fx, #tlf-shop .tlf2-safe-copy li').forEach(function (p) {
      var t = p.textContent || '';
      if (/moneda base de la tienda es USD/i.test(t)) {
        p.textContent = 'La tienda cobra en pesos mexicanos. Debajo de cada precio puedes ver el equivalente aproximado en tu moneda, solo como referencia.';
      } else if (/confirmación de pago muestra el precio en USD/i.test(t)) {
        p.textContent = 'La confirmación de pago muestra el precio en pesos mexicanos.';
      } else if (/El equivalente en USD es solo referencia/i.test(t)) {
        p.textContent = 'Pagas en pesos mexicanos: el precio en MXN de cada ficha es el que se te cobra al pagar. El equivalente en otras monedas es solo una referencia con el tipo de cambio del día.';
      }
    });
    document.querySelectorAll('#tlf-shop .tlf2-faq summary').forEach(function (s) {
      if (/¿Por qué el pago aparece en USD\?/i.test(s.textContent || '')) s.textContent = '¿En qué moneda se cobra?';
    });
  }

  function paint() {
    killOldUsd();
    if (!rates || !cur || cur === 'MXN') {
      document.querySelectorAll('.tl-alt').forEach(function (n) { n.remove(); });
      return;
    }
    var r = rates[cur];
    if (!r) return;
    document.querySelectorAll('#tlf-shop .tlf2-price, #tlf2-modal .tlf2-modal-price').forEach(function (box) {
      var card = box.closest('[data-mxn]');
      var mxn = card ? Number(card.dataset.mxn) : null;
      if (!mxn) {
        var strong = box.querySelector('strong');
        if (strong) mxn = Number((strong.textContent || '').replace(/[^\d]/g, ''));
      }
      if (!mxn) return;
      var alt = box.querySelector('.tl-alt');
      if (!alt) {
        alt = document.createElement('span');
        alt.className = 'tl-alt';
        alt.style.cssText = 'display:block;width:100%;margin-top:3px;color:#a9d8ff;font-size:12px;font-weight:800';
        box.appendChild(alt);
      }
      var _tx = '≈ ' + fmt(mxn * r, cur);
      if (alt.textContent !== _tx) alt.textContent = _tx;
    });
  }

  function picker() {
    var host = document.querySelector('#tlf-shop .tlf2-controls');
    if (!host || document.getElementById('tl-cur-sel')) return;
    var wrap = document.createElement('label');
    wrap.style.cssText = 'display:flex;align-items:center;gap:8px;color:#b9a9d6;font:800 12px/1 Inter,system-ui,sans-serif;margin-top:8px';
    wrap.innerHTML = '<span>Ver precios en</span>';
    var sel = document.createElement('select');
    sel.id = 'tl-cur-sel';
    sel.style.cssText = 'padding:9px 12px;border-radius:10px;border:1px solid #4c3a82;background:#120b1b;color:#fff;font:800 13px/1 inherit';
    LIST.forEach(function (x) {
      var o = document.createElement('option');
      o.value = x.c;
      o.textContent = x.c + ' · ' + x.n;
      sel.appendChild(o);
    });
    sel.value = cur;
    sel.addEventListener('change', function () { cur = sel.value; save(cur); paint(); });
    wrap.appendChild(sel);
    host.appendChild(wrap);
    var p = document.createElement('p');
    p.id = 'tl-cur-note';
    p.style.cssText = 'margin:6px 0 0;color:#8f86a6;font-size:11px;line-height:1.4';
    p.textContent = 'El cobro siempre se hace en pesos mexicanos. El precio en tu moneda es una referencia con el tipo de cambio de hoy.';
    host.appendChild(p);
  }

  function boot() {
    killSwitcher();
    killOldUsd();
    fixCopy();
    cur = load() || guess();
    picker();
    if (cur === 'MXN') { document.querySelectorAll('.tl-alt').forEach(function (n) { n.remove(); }); setTimeout(killSwitcher, 1500); return; }
    fetch('https://open.er-api.com/v6/latest/MXN')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.rates) return;
        rates = d.rates;
        paint();
        var t = null, last = '';
        var mo = new MutationObserver(function () {
          var sg = document.querySelectorAll('[data-mxn]').length + '|' + ((document.getElementById('tlf2-modal-name') || {}).textContent || '');
          if (sg === last) return;
          last = sg;
          clearTimeout(t); t = setTimeout(paint, 250);
        });
        mo.observe(document.getElementById('tlf2-modal') || document.body, { childList: true, subtree: true });
      })
      .catch(function () {});
    setTimeout(killSwitcher, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
